import Heading from './Heading';
import { View } from 'foundations-components/components/View';
import ActivityButtonsContainer from './ActivityButtonsContainer';
import ProfileHighlightAlertsAsync from 'card-preview-highlight-lib/crm_ui/profile/sidebar/highlight/ProfileHighlightAlertsAsync';
import { useCardContextValue } from '../state/CardContext';
import { useGetIsScoped } from 'crm-cards-sdk/hooks/useGetIsScoped';
import RecordDetailsWithAvatar from './RecordDetailsWithAvatar';
import CardSkeleton from './skeleton/CardSkeleton';
import MiniHighlight from './MiniHighlight';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function CardContent() {
  var _subjectPermissionsRe;
  const [highlightContainerRef, setHighlightContainerRef] = useState(null);
  const {
    objectTypeId,
    propertyNames,
    asyncData: {
      subjectPermissionsResult,
      subjectResult,
      objectTypeDefinitionResult,
      propertyDefinitionsResult
    }
  } = useCardContextValue();
  const getIsScoped = useGetIsScoped();
  if (!subjectResult.data || !objectTypeDefinitionResult.data || !propertyDefinitionsResult.data || !subjectPermissionsResult.data) {
    return /*#__PURE__*/_jsx(CardSkeleton, {
      objectTypeId: objectTypeId,
      numberOfProperties: propertyNames.length
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MiniHighlight, {
      highlightContainerRef: highlightContainerRef
    }), /*#__PURE__*/_jsxs("div", {
      ref: setHighlightContainerRef,
      "data-test-id": "record-highlight-content",
      children: [/*#__PURE__*/_jsx(Heading, {}), /*#__PURE__*/_jsxs(View, {
        padding: "500",
        children: [/*#__PURE__*/_jsx(ProfileHighlightAlertsAsync, {
          objectTypeId: objectTypeId,
          isEditable: subjectPermissionsResult === null || subjectPermissionsResult === void 0 || (_subjectPermissionsRe = subjectPermissionsResult.data) === null || _subjectPermissionsRe === void 0 || (_subjectPermissionsRe = _subjectPermissionsRe.crmObject) === null || _subjectPermissionsRe === void 0 || (_subjectPermissionsRe = _subjectPermissionsRe.userPermissions) === null || _subjectPermissionsRe === void 0 ? void 0 : _subjectPermissionsRe.currentUserCanEdit,
          subject: subjectResult.data,
          getIsScoped: getIsScoped,
          children: /*#__PURE__*/_jsx(RecordDetailsWithAvatar, {
            isEditable: false
          })
        }), /*#__PURE__*/_jsx(RecordDetailsWithAvatar, {}), /*#__PURE__*/_jsx(ActivityButtonsContainer, {})]
      })]
    })]
  });
}